export class BaitItem {
    #type;
    #viewType;

    constructor(type, viewType) {
        this.#type = type;
        this.#viewType = viewType;
    }

    get type() {
        return this.#type;
    }

    get viewType() {
        return this.#viewType;
    }
}
